export default __webpack_public_path__ + "static/media/hero-portrait.bbd5dda0.jpg";